import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import Highcharts from 'highcharts';
import { HighChartsI18n } from '@shared/components/highcharts/i18n';

@Component({
  selector: 'app-bar-horizontal',
  templateUrl: './bar-horizontal.component.html',
  styleUrls: ['./bar-horizontal.component.scss'],
})
export class BarHorizontalComponent implements AfterViewInit, OnChanges {
  @ViewChild('chart') chart: ElementRef;

  @Input() data: Highcharts.Options = {};

  @Output() barClicked = new EventEmitter<Object>();
  @Output() categoryClicked = new EventEmitter<string>();
  @Output() isRendered = new EventEmitter<void>();

  constructor(private readonly i18n: HighChartsI18n) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data && changes.data.currentValue) {
      this.data = changes.data.currentValue;
      this.drawChart(this.data);
    }
  }

  ngAfterViewInit() {
    this.drawChart(this.data);
  }

  barClick = (event: any) => {
    this.barClicked.emit(event);
  };

  drawChart(options: Highcharts.Options) {
    if (!this.chart?.nativeElement || !options?.chart) return;

    options = this.setGlobalOptions(options);
    // TODO: use arrow functions

    Highcharts.chart(options, (chart) => {
      const categories = chart.xAxis?.[0]?.categories;

      Object.values(chart.xAxis?.[0]?.ticks ?? {}).forEach((tick: any) => {
        tick.label?.on('click', (el: any) => {
          const override = (el.target as HTMLElement)?.closest?.('.category-override')?.textContent?.trim();
          const category = override || (categories?.[tick.pos] ?? tick.label?.textStr);
          if (category != null) this.categoryClicked.emit(String(category));
        });
      });
    });
  }

  setGlobalOptions(data: Highcharts.Options) {
    data.chart.events = {
      render: () => {
        this.isRendered.emit();
      },
    };

    data.chart.renderTo = this.chart.nativeElement;

    data.plotOptions.series.cursor = 'pointer';
    data.plotOptions.series.events.click = this.barClick;

    data.lang = this.i18n.langOptions;

    return data;
  }
}
